import type { TemplateItem } from 'inspection-types';
import type { AddItemToTemplateParams } from 'react-hooks';

export type UnhideQuestionInput = {
  channelId: string;
  templateId: string;
  sectionId: string;
  item: TemplateItem;
};

export function buildUnhideQuestionParams({
  channelId,
  templateId,
  sectionId,
  item,
}: UnhideQuestionInput): AddItemToTemplateParams {
  const { removed: _removed, ...storedItem } = item;

  return { channelId, templateId, sectionId, item: storedItem };
}
